
<div id="id01" class="modal-login" *ngIf="pwdBlock">
    <!-- Modal content-->
    <div class="modal-content-login" *ngIf="!resetpwdBlock && !resetpwdSuccessBlock">
     <div class="modal-header">
			<div><h4 class="modal-title">{{ 'Login.Authentication' | translate }}</h4></div>
		    <div><p>{{ 'Login.LoginRegAlert' | translate }}.</p></div>
			<div><button type="button" class="close closeButton" (click)="closefn()">&times;</button></div>
          
     </div>
     <div class="modal-body loginBody">
          <input type="text" class="form-control inputFields" name="Email"  [(ngModel)]="email" placeholder="{{ 'Common.Email' | translate }}" required>
		  <span class="alert-error">{{emailError}}</span><span class="alert-error">{{emailValidateError}}</span>
		  <input type="password" (keydown.enter)="login()" class="form-control inputFields" name="Password"  [(ngModel)]="password" placeholder="{{ 'Common.Password' | translate }}" required>
		  <span class="alert-error">{{passwordError}}</span>
     </div>
	<div class="modal-footer loginFooter" style="background-color:#e5e5e5">
	  <button type="button" class="reset-btn-login" data-toggle="modal" data-target="#myModal" (click)="closefn()">{{ 'Common.Register' | translate }}</button>{{ 'Common.OR' | translate }}
	  <button type="button" class="btn btn-info btn-width" (click)="login()">{{ 'Common.Login' | translate }}</button>
	  <div><a href="#" class="btn-resetpwd" (click)="resetPasswordBlockShow()">{{ 'Login.Resetpassword' | translate }}</a></div>
	</div>
  </div>
  
  <div class="modal-content-login" *ngIf="resetpwdBlock && !resetpwdSuccessBlock">
     <div class="modal-header">
			<div><h4 class="modal-title">{{ 'Login.Resetpassword' | translate }}</h4></div>
		    <div><p>{{ 'Login.EnterEmailAlert' | translate }}.</p></div>
			<div><button type="button" class="close closeButton" (click)="closefn()">&times;</button></div>
          
     </div>
     <div class="modal-body loginBody">
          <input type="text" (keydown.enter)="resetPassword()" class="form-control inputFields" name="Email"  [(ngModel)]="email" placeholder="{{ 'Common.Email' | translate }}" required>
		  <span class="alert-error">{{resetemailError}}</span><span class="alert-error">{{resetemailValidateError}}</span>
     </div>
	<div class="modal-footer loginFooter" style="background-color:#e5e5e5">
	  <button type="button" class="reset-btn-login" (click)="goToLogin()">{{ 'Common.Login' | translate }}</button>{{ 'Common.OR' | translate }}
	  <button type="button" class="btn btn-info btn-width" (click)="resetPassword()">{{ 'Login.Reset' | translate }}</button>
	  
	</div>
  </div>
  <div class="modal-content-login" *ngIf="resetpwdSuccessBlock">
     <div class="modal-header">
			<div><h4 class="modal-title">{{ 'Login.CheckMail' | translate }}</h4></div>
		    <div><p>{{ 'Login.Instruction' | translate }}  </p></div>
			<div><button type="button" class="close closeButton" (click)="closefn()">&times;</button></div>
     </div>
     <div class="modal-body loginBody">
          <div>{{ 'Login.Info' | translate }}<span style="display:block">{{ 'Login.NoMailInstruction' | translate }}</span></div>
     </div>
	<div class="modal-footer loginFooter" style="background-color:#e5e5e5">
	  <div>{{ 'Login.Tip' | translate }}<span style="display:block">{{ 'Login.AddAddressInstruction' | translate }}</span></div>
	  <div><span style="display:block">&#169;{{currentYear()}} {{ 'Login.UnifiedInbox' | translate }}</span></div>
	</div>
  </div>
</div>
